import { useQuery } from '@tanstack/react-query';
import { AbTestsResponseError } from '../api/ab-tests-response';
import { getAbTests } from '../api/analytics';

export function useGetAbTests(params: {
  variant?: string;
  utm_source?: string;
  utm_campaign?: string;
  region?: string;
  user_id?: string;
  enabled?: boolean;
}) {
  const {
    variant,
    utm_source,
    utm_campaign,
    region,
    user_id,
    enabled = true,
  } = params;

  return useQuery({
    queryKey: ['ab-tests'],
    queryFn: ({ signal }) =>
      getAbTests({
        variant,
        utm_source,
        utm_campaign,
        region,
        user_id,
        abortSignal: signal,
      }),
    enabled,
    retry: (failureCount, error) => {
      if (failureCount >= 1 || error.name === 'AbortError') return false;
      if (error instanceof AbTestsResponseError) {
        if (error.reason === 'invalid_payload') return false;
        const { status } = error.details;
        if (status >= 400 && status < 500 && status !== 408 && status !== 429) {
          return false;
        }
      }
      return true;
    },
    retryDelay: 500,
    staleTime: 24 * 60 * 60 * 1000, // 24 часа
  });
}
